import React from "react";
import Project from "./index";

export function ProjectCanceled() {
  return <Project status="Annulé" />;
}